import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Placeholder } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { cloneDeep } from 'lodash-es'
import { getSummaryOfGrade } from '../../../redux/actions/auditDashboard'

export default function SummaryOfGradeChart({ request }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const [chartOption, setChartOption] = useState()
  // console.log('request==>', request)
  useEffect(() => {
    handleGetSchema()
  }, [request])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSummaryOfGrade(request)
      // console.log('response==>', response)
      // const response = mockSchema
      let charts = cloneDeep(chartSchema)
      charts.title.text = response?.chartTitle || 'ระดับคะแนนโครงการ(เกรด)'
      charts.series[0].data = response?.chartDatas

      // console.log(JSON.stringify(charts))

      setSchema(response)
      setChartOption(charts)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 20 }}
          shaded
        >
          {isLoading && <Placeholder.Graph active />}
          {chartOption && (
            <ReactECharts
              theme={CHART_THEME}
              option={chartOption}
              style={{ minHeight: '400px', width: '100%' }}
              className={'react_for_echarts'}
            />
          )}
        </Panel>
      )}
    </>
  )
}

const colorPalette = ['#41b596', '#ffc184', '#63c2ff', '#b6a2de', '#dd8b90']

const chartSchema = {
  title: {
    text: '',
    subtext: '',
    left: 'left',
    top: '10',
    textStyle: {
      color: '#008acd',
      opacity: '0.7',
      fontWeight: '400',
      fontSize: '1rem',
    },
  },
  tooltip: {
    trigger: 'item',
  },
  legend: {
    orient: 'vertical',
    top: '40',
    left: 'right',
    // data: ['เกรด A', 'เกรด B', 'เกรด C', 'เกรด D', 'เกรด F'],
  },
  toolbox: {
    show: true,
    feature: {
      //dataView: { show: true, readOnly: false },
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  series: [
    {
      name: 'ระดับคะแนนโครงการ',
      type: 'pie',
      radius: '70%',
      stillShowZeroSum: false,
      data: [],
      color: colorPalette,
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
}
